import React from "react";
import { connect } from "react-redux";
import Loader from "../loaders/Loader";
import "./cardinfo.scss";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { addLoader, removeLoader, fetchJobs } from "../../actions";

class CardInfo extends React.Component {
  componentDidMount = async () => {
    this.props.addLoader();
    await this.props.fetchJobs();
    this.props.removeLoader();
  };

  renderList = () => {
    if (this.props.isLoading) {
      return Array(15).fill(<Loader />);
    }

    return this.props.jobs.map((job) => {
      if (job.length < 50 && this.props.buttonRef.current) {
        this.props.buttonRef.current.classList.add("hidder");
      } else if (this.props.buttonRef.current) {
        this.props.buttonRef.current.classList.remove("hidder");
      }

      return job.map((j) => {
        return (
          <li
            className={`jobs__list--item ${
              this.props.darkMode ? "dark--3" : ""
            }`}
            key={j.id}
          >
            <div className="jobs__list--imagebox" style={{}}>
              <img src={j.company_logo} alt="Logo" />
            </div>
            <div className="jobs__list--top">
              <p className="jobs__list--top--item">
                <Moment fromNow>
                  <Moment format="YYYY/MM/DD">{j.created_at}</Moment>
                </Moment>
              </p>
              <p className="jobs__list--top--item">{j.type}</p>
            </div>
            <div className="jobs__list--middle">
              <Link
                className={`jobs__list--middle--name ${
                  this.props.darkMode ? "white" : ""
                }`}
                to={`/jobs/${j.id}`}
              >
                {j.title}
              </Link>
              <h3 className="jobs__list--middle--company">{j.company}</h3>
            </div>
            <div className="jobs__list--bottom">
              <p className="jobs__list--bottom--location">{j.location}</p>
            </div>
          </li>
        );
      });
    });
  };
  render() {
    return <React.Fragment>{this.renderList()}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {
    jobs: state.jobs,
    formValues: state.form,
    isLoading: state.loader.isLoading,
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps, { addLoader, removeLoader, fetchJobs })(
  CardInfo
);
